import neoHubDomain from './neoHubDomain';
import { canManageCompany, canManageTenants } from './routeAuthorities';

const getPagesAndTrackType = (user = {}) => {
  const {
    rolesList: [{ permissions: { designer } = {} } = {}] = [],
    retailerId,
    retailerIdToRetailerInfo: { [retailerId]: { products } = {} } = {},
  } = user;

  // Shared with the route guards in `routeAuthorities` so that "where we land
  // this user" and "which pages this user may open" cannot drift apart
  // (CPMT-5077).
  const tenantsPage = canManageTenants(user);
  const companyPage = canManageCompany(user);

  const assetsPageOrTrackExperiencesPage = designer && designer.all;

  const dynamicTrack =
    Array.isArray(products) && products.indexOf('Track Beta') > -1;

  return {
    tenantsPage,
    companyPage,
    assetsPageOrTrackExperiencesPage,
    dynamicTrack,
  };
};

export default (user, homepageEnabled) => {
  const isNarvarEmployee = user.rolesList.some(role =>
    role.name.startsWith('NARVAR_'),
  );

  if (
    homepageEnabled &&
    (isNarvarEmployee === false || user.customerSupportLogin === true)
  ) {
    return {
      external: false,
      url: '/home',
    };
  }

  const {
    tenantsPage,
    companyPage,
    assetsPageOrTrackExperiencesPage,
    dynamicTrack,
  } = getPagesAndTrackType(user);

  if (tenantsPage) {
    return {
      external: false,
      url: '/admin/tenants',
    };
  }

  if (companyPage) {
    return {
      external: false,
      url: '/admin/users',
    };
  }

  if (assetsPageOrTrackExperiencesPage) {
    return {
      external: dynamicTrack,
      url: dynamicTrack ? `${neoHubDomain()}/track/versions` : '/track/assets',
    };
  }

  return {
    external: dynamicTrack,
    url: dynamicTrack
      ? `${neoHubDomain()}/track/analytics`
      : '/track/analytics',
  };
};
